import React from "react";

import BodyText from "core/BodyText";
import PasswordLoginViewLink from "../links/PasswordLoginViewLink";

import { useLoginFlow } from "../Context";

import { CtaButton, FooterTextStyled, FormInputStyled } from "../styles";

import { validEmail } from "../../helpers";

const CodeRequestView = () => {
    const {
        emailAddress,
        setEmailAddress,
        startLoginCodeRequest,
        isProcessing
    } = useLoginFlow();

    return (
        <>
            <FormInputStyled
                name="username"
                autocomplete="username"
                labelText="Email Address"
                placeholderText="yourname@domain.com"
                value={emailAddress}
                onChange={setEmailAddress}
                type="text"
                validation={[
                    {
                        errorMsg: "Please enter a valid email.",
                        isValid: validEmail
                    }
                ]}
                data-testid="email-address-input"
            />
            <CtaButton
                onClick={e => {
                    e.preventDefault();
                    startLoginCodeRequest();
                }}
                isProcessing={isProcessing}
                isDisabled={!validEmail(emailAddress)}
            >
                Send Login Code
            </CtaButton>
            <FooterTextStyled>
                <BodyText type="p">
                    Can't access your email?{" "}
                    <PasswordLoginViewLink>
                        Login with password
                    </PasswordLoginViewLink>
                    .
                </BodyText>
            </FooterTextStyled>
        </>
    );
};

export default CodeRequestView;
